import React, { useEffect, useRef, useState } from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import StrapiMedia from "../strapi-media"
import { useReadMoreButton, useSameHeightElements } from "../../hooks"

const PackageOptions = ({
  packageOptions,
  title,
  underlineBand,
  borderBottom,
  htmlDesc,
}) => {
  const data = packageOptions?.data
    ? JSON.parse(JSON.stringify(packageOptions.data))
    : []

  const [packageOptionsRender, setPackageOptionsRender] = useState(data)

  const timerRef = useRef(null)

  useEffect(() => {
    timerRef.current = () => {
      const newPackageOptionsRender = [...packageOptionsRender]
      setPackageOptionsRender(newPackageOptionsRender)
    }
  }, [packageOptionsRender])

  const reRenderPackageOptions = action => {
    const newPackageOptionsRender =
      action === "next"
        ? [
            packageOptionsRender[1],
            packageOptionsRender[2],
            packageOptionsRender[0],
          ]
        : [
            packageOptionsRender[2],
            packageOptionsRender[0],
            packageOptionsRender[1],
          ]
    setPackageOptionsRender(newPackageOptionsRender)
    setTimeout(() => timerRef.current(), 500)
  }

  // Read More
  const packageOptionSection = useRef(null)

  useSameHeightElements(packageOptionSection, ".pk-description")
  useReadMoreButton(packageOptionSection, "Read More", "Read Less")

  if (!packageOptions?.data) return <div></div>

  return (
    <div className="pt-20" ref={packageOptionSection}>
      <div className="max-w-screen-2xl mx-auto">
        <h3 className="font-cardo sm:font-cardo--46 lg:font-cardo--53 text-center leading-none px-5 lg:mb-20">
          {title}
        </h3>
        {!title && <div dangerouslySetInnerHTML={{ __html: htmlDesc }}></div>}
        <div className="my-10 px-5 sm:px-10 lg:hidden flex flex-row place-content-end">
          <button
            className="flex flex-row items-center cursor-pointer mr-5"
            onClick={() => reRenderPackageOptions("prev")}
          >
            <StaticImage
              src="../../static/images/icon/angle-arrow-left.svg"
              alt="arrow-left"
            />
          </button>
          <button
            className="flex flex-row items-center cursor-pointer"
            onClick={() => reRenderPackageOptions("next")}
          >
            <StaticImage
              src="../../static/images/icon/angle-arrow-right.svg"
              alt="arrow-right"
            />
          </button>
        </div>
      </div>
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex flex-row">
          {packageOptionsRender.map((option, index) => {
            const { titleHtml, description, concepts, button } =
              option.attributes
            return (
              <div
                key={option.id}
                className={`relative lg:w-1/3 lg:inline-block pt-10 pb-40 px-10 sm:px-8 lg:px-5 lg:mx-3 ${
                  option.class || ""
                } bg-white ${
                  index === 1 ? "w-full sm:w-3/4 mx-auto" : "hidden"
                }`}
              >
                <div className="pk-description pt-10">
                  <div
                    className="font-cardo"
                    dangerouslySetInnerHTML={{ __html: titleHtml }}
                  ></div>
                  <div
                    className="font-montserrat--18 py-10 leading-[34px]"
                    dangerouslySetInnerHTML={{ __html: description }}
                  ></div>
                </div>
                <div className="grid grid-cols-2 gap-x-2">
                  {concepts.data.map(concept => {
                    const { title, band, image, concept_options } =
                      concept.attributes
                    return (
                      <div key={title + band} className="text-left">
                        <StrapiMedia image={image} />
                        <p className="font-syne--17 sm:font-syne--22 lg:font-syne--17 xl:font-syne--22 font-semibold my-3">
                          {title}
                        </p>
                        <p className="font-semibold my-3 tracking-[2px]">
                          {band}
                        </p>
                        <ul className="font-montserrat--14 leading-loose">
                          {concept_options.data.map(content => (
                            <li
                              className="flex flex-row"
                              key={content.attributes.value}
                            >
                              <span>-</span>{" "}
                              <span
                                className={`ml-1 ${
                                  underlineBand ? "underline" : ""
                                }`}
                              >
                                {content.attributes.value}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                  })}
                </div>
                <Link
                  to="/quote/"
                  className="absolute bottom-10 btn btn--primary block mx-auto left-1/2 transform -translate-x-1/2 whitespace-nowrap qbutton"
                >
                  {button}
                </Link>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default PackageOptions
